import { object, string } from "yup";

export const getValidationSchema = (t) =>
  object().shape({
    address1: string()
      .required(t("residence.validation.addressRequired"))
      .min(2, t("residence.validation.addressMin"))
      .max(100, t("residence.validation.addressMax")),
    city: string()
      .required(t("residence.validation.cityRequired"))
      .min(2, t("residence.validation.cityMin"))
      .max(100, t("residence.validation.cityMax")),
    state: string()
      .required(t("residence.validation.stateRequired"))
      .max(2, t("residence.validation.stateIdentifier"))
      .matches(
        /^([A-Za-zÀ-ÖØ-öø-ÿ\s]*)$/gi,
        t("residence.validation.stateLettersOnly")
      ),
    zip: string()
      .required(t("residence.validation.zipRequired"))
      .min(5, t("residence.validation.zipMin"))
      .max(5),
    fromDate: string()
      .min(10, t("residence.validation.dateFormat"))
      .max(10)
      .required(t("residence.validation.fromDateRequired")),
    untillDate: string()
      .min(10, t("residence.validation.dateFormat"))
      .max(10)
      .required(t("residence.validation.untilDateRequired")),
  });

export const getResidenceInputs = (t) => [
  {
    name: "address1",
    label: t("residence.fields.address1.label"),
    type: "text",
    placeholder: t("residence.fields.address1.placeholder"),
  },
  {
    name: "address2",
    label: t("residence.fields.address2.label"),
    type: "text",
    placeholder: t("residence.fields.address2.placeholder"),
  },
  {
    name: "city",
    label: t("residence.fields.city.label"),
    type: "text",
    placeholder: t("residence.fields.city.placeholder"),
  },
  {
    name: "state",
    label: t("residence.fields.state.label"),
    type: "text",
    placeholder: t("residence.fields.state.placeholder"),
  },
  {
    name: "zip",
    label: t("residence.fields.zip.label"),
    type: "text",
    placeholder: t("residence.fields.zip.placeholder"),
  },
  {
    name: "fromDate",
    label: t("residence.fields.fromDate.label"),
    type: "date",
    placeholder: t("residence.fields.fromDate.placeholder"),
  },
  {
    name: "untillDate",
    label: t("residence.fields.untilDate.label"),
    type: "date",
    placeholder: t("residence.fields.untilDate.placeholder"),
  },
];
